import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CYLINDO_OPTIONS, CYLINDO_ACCOUNT_ID, FABRIC_PRODUCT_OPTION_ID, LEATHER_PRODUCT_OPTION_ID, PANTONE_FABRIC_CONFIG } from 'commons/constants';
import { orientationOptionIds } from 'components/consumer/OrientationPDPModal';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useCylindoDimensionShots from '../useCylindoDimensionShots';
import useCylindoCache from './cylindoCache/useCylindoCache';
import { DISABLED_UPHOLSTERY, EMPTY_ARRAY, EMPTY_OBJECT, SUNBRELLA_NAME_MISMATCH_OPTIONS, CYLINDO_FRAMES_TO_SHOW, CYLINDO_CONTENT_API } from './cylindoCache/defaults';
const usePDPCylindoViewer = t0 => {
  const $ = _c(41);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isPDPDesktop: t2,
    material: t3
  } = t1;
  const isPDPDesktop = t2 === undefined ? false : t2;
  const material = t3 === undefined ? null : t3;
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t4
  } = usePDPOptions();
  const {
    selectedOptionsExtended
  } = t4;
  const productId = basicDetails?.id;
  const isCylindoProduct = !!basicDetails?.custom_properties?.cylindo_product;
  const {
    config: cylindoProductConfig,
    version: cylindoVersion,
    loading
  } = useCylindoCache(productId, isCylindoProduct);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ...SUNBRELLA_NAME_MISMATCH_OPTIONS,
      ...PANTONE_FABRIC_CONFIG.pantoneFabricCylindoNameMapping
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const nameMismatchOptions = t5;
  let t6;
  if ($[3] !== cylindoProductConfig || $[4] !== material?.label || $[5] !== productId || $[6] !== selectedOptionsExtended) {
    t6 = () => {
      if (!productId || !cylindoProductConfig || !selectedOptionsExtended) {
        return null;
      }
      const upholsteryName = material?.label ?? selectedOptionsExtended[FABRIC_PRODUCT_OPTION_ID]?.value?.value ?? selectedOptionsExtended[LEATHER_PRODUCT_OPTION_ID]?.value?.value ?? null;
      if (!upholsteryName) {
        return null;
      }
      const correctedUpholsteryName = nameMismatchOptions[upholsteryName] || upholsteryName;
      return correctedUpholsteryName.trim().replace("\u2122", "").toUpperCase();
    };
    $[3] = cylindoProductConfig;
    $[4] = material?.label;
    $[5] = productId;
    $[6] = selectedOptionsExtended;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  material?.label;
  let t7;
  if ($[8] !== t6) {
    t7 = t6();
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const upholsteryKey = t7;
  const hasUpholsteryOption = !!upholsteryKey;
  let t8;
  if ($[10] !== cylindoVersion || $[11] !== upholsteryKey) {
    t8 = {
      upholsteryKey,
      cylindoVersion
    };
    $[10] = cylindoVersion;
    $[11] = upholsteryKey;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const dimensionShotsData = useCylindoDimensionShots(t8);
  let t9;
  bb0: {
    if (!upholsteryKey || DISABLED_UPHOLSTERY.includes(upholsteryKey)) {
      t9 = undefined;
      break bb0;
    }
    let t10;
    if ($[13] !== cylindoProductConfig.features || $[14] !== upholsteryKey) {
      const upholsteryFeature = cylindoProductConfig.features?.find(_temp);
      t10 = upholsteryFeature?.options.find(opt => opt.code?.toUpperCase() === upholsteryKey);
      $[13] = cylindoProductConfig.features;
      $[14] = upholsteryKey;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    const upholsteryOption = t10;
    if (!upholsteryOption) {
      t9 = undefined;
      break bb0;
    }
    let t11;
    if ($[16] !== upholsteryOption.code) {
      t11 = {
        [CYLINDO_OPTIONS.UPHOLSTERY]: upholsteryOption.code
      };
      $[16] = upholsteryOption.code;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    t9 = t11;
  }
  const upholsteryFeatureDetails = t9;
  const isUpholsteryFeatureAvailable = !!upholsteryFeatureDetails;
  const orientationId = orientationOptionIds.find(id => selectedOptionsExtended[id]);
  const orientationValue = selectedOptionsExtended[orientationId]?.value?.value;
  let t10;
  if ($[18] !== orientationValue) {
    t10 = orientationValue?.toUpperCase();
    $[18] = orientationValue;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const orientationKey = t10;
  const hasOrientationOption = !!orientationKey;
  let t11;
  if ($[20] !== cylindoProductConfig?.features || $[21] !== orientationKey) {
    t11 = () => {
      if (!orientationKey) {
        return;
      }
      const orientationFeature = cylindoProductConfig?.features?.find(_temp2);
      const orientationKeyStr = String(orientationKey).trim().toLowerCase();
      const orientationOption = orientationFeature?.options?.find(opt_0 => String(opt_0.code).trim().toLowerCase() === orientationKeyStr);
      if (!orientationOption) {
        return;
      }
      return {
        [CYLINDO_OPTIONS.ORIENTATION]: orientationOption.code
      };
    };
    $[20] = cylindoProductConfig?.features;
    $[21] = orientationKey;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  cylindoProductConfig?.features;
  let t12;
  if ($[23] !== t11) {
    t12 = t11();
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const orientationOptionDetails = t12;
  const isOrientationFeatureAvailable = !!orientationOptionDetails;
  const areAllFeaturesAvailable = (!hasUpholsteryOption || hasUpholsteryOption && isUpholsteryFeatureAvailable) && (!hasOrientationOption || hasOrientationOption && isOrientationFeatureAvailable);
  let t13;
  bb1: {
    if (!upholsteryFeatureDetails && !orientationOptionDetails) {
      t13 = EMPTY_OBJECT;
      break bb1;
    }
    const t14 = upholsteryFeatureDetails || EMPTY_OBJECT;
    const t15 = orientationOptionDetails || EMPTY_OBJECT;
    let t16;
    if ($[25] !== t14 || $[26] !== t15) {
      t16 = {
        ...t14,
        ...t15
      };
      $[25] = t14;
      $[26] = t15;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    t13 = t16;
  }
  const cylindoFeatures = t13;
  let t14;
  bb2: {
    if (isPDPDesktop && areAllFeaturesAvailable && Object.entries(cylindoFeatures).length) {
      let t15;
      if ($[28] !== cylindoFeatures) {
        t15 = Object.entries(cylindoFeatures).map(_temp3);
        $[28] = cylindoFeatures;
        $[29] = t15;
      } else {
        t15 = $[29];
      }
      const featuresString = t15.join("&feature=");
      let t16;
      if ($[30] !== featuresString || $[31] !== productId) {
        t16 = CYLINDO_FRAMES_TO_SHOW.map((frame, index) => ({
          id: frame,
          index,
          src: `${CYLINDO_CONTENT_API}/${CYLINDO_ACCOUNT_ID}/products/${productId}/frames/${frame}?feature=${featuresString}`,
          type: "cylindo"
        }));
        $[30] = featuresString;
        $[31] = productId;
        $[32] = t16;
      } else {
        t16 = $[32];
      }
      t14 = t16;
      break bb2;
    }
    t14 = EMPTY_ARRAY;
  }
  const cylindoConfigurationPhotos = t14;
  const t15 = !!cylindoProductConfig && areAllFeaturesAvailable;
  const t16 = isCylindoProduct && !!cylindoProductConfig && areAllFeaturesAvailable && cylindoConfigurationPhotos?.length > 0;
  let t17;
  if ($[33] !== cylindoConfigurationPhotos || $[34] !== cylindoFeatures || $[35] !== dimensionShotsData || $[36] !== loading || $[37] !== t15 || $[38] !== t16 || $[39] !== upholsteryKey) {
    t17 = {
      cylindoConfigurationPhotos,
      cylindoFeatures,
      isCylindoAvailable: t15,
      loading,
      isCylindoConfigurationPhotos: t16,
      upholsteryKey,
      ...dimensionShotsData
    };
    $[33] = cylindoConfigurationPhotos;
    $[34] = cylindoFeatures;
    $[35] = dimensionShotsData;
    $[36] = loading;
    $[37] = t15;
    $[38] = t16;
    $[39] = upholsteryKey;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  return t17;
};
export default usePDPCylindoViewer;
function _temp(feat) {
  return feat.code === CYLINDO_OPTIONS.UPHOLSTERY;
}
function _temp2(feat_0) {
  return feat_0.code === CYLINDO_OPTIONS.ORIENTATION;
}
function _temp3(t0) {
  const [featureKey, featureCode] = t0;
  return `${featureKey}:${featureCode}`;
}